import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';
import { NavLink } from 'react-router-dom';

import {
  STUDIO_SETTINGS_LABELS,
  STUDIO_SETTINGS_PATHS,
  STUDIO_SETTINGS_SECTIONS,
} from './settings-nav.js';
import './SettingsLayout.css';

export function StudioSettingsNav(): ReactElement {
  return (
    <nav className="studio-settings__nav" aria-label={t('common.studio.settings.navLabel')}>
      {STUDIO_SETTINGS_SECTIONS.map((section) => (
        <NavLink
          key={section}
          to={STUDIO_SETTINGS_PATHS[section]}
          className={({ isActive }) =>
            isActive ? 'studio-settings__link studio-settings__link--active' : 'studio-settings__link'
          }
        >
          {t(STUDIO_SETTINGS_LABELS[section])}
        </NavLink>
      ))}
    </nav>
  );
}
